import { AzureAuthConfiguration, AzureAuthProvider } from "@datamole/wds-azure-auth";
import { Tooltip } from "@datamole/wds-component-tooltip";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";

import { Input } from "@/components/ui/input";
import { config } from "@/config";
import ErrorPage from "@/pages/error-page";
import { AppRoutes } from "@/routes/app-routes";
import { store } from "@/store";
import "@/styles/normalize.css";
import "@/styles/fonterra.theme.css";
import "@/styles/global.css";
import { loadGtm } from "@/utils/load-gtm/load-gtm";

const azureAuthConfiguration: AzureAuthConfiguration = {
    authorityUrl: config.AZURE_AUTH_AUTHORITY_URL,
    clientId: config.AZURE_AUTH_CLIENT_ID,
    redirectUrl: config.AZURE_AUTH_REDIRECT_URL,
};

/**
 * Component representing the main application
 *
 * @returns rendered application
 */
const App = () => {
    useEffect(() => {
        loadGtm(config.GTM_ID);
    }, []);

    return (
        <Provider store={store}>
            <ErrorBoundary fallback={<ErrorPage />}>
                {/**
                 * HOTFIX: To guarantee correct order of loaded WDS components styles,
                 * we need import 'Input' before 'Combobox' and 'List' before 'Menu'
                 */}
                <Input style={{ display: "none" }} />
                <AzureAuthProvider configuration={azureAuthConfiguration}>
                    <Tooltip.Provider>
                        <AppRoutes />
                    </Tooltip.Provider>
                </AzureAuthProvider>
            </ErrorBoundary>
        </Provider>
    );
};

export { App };
